import { render } from "./Logo-component.vue?vue&type=template&id=f294b820&scoped=true"
import script from "./Logo-component.vue?vue&type=script&lang=js"
export * from "./Logo-component.vue?vue&type=script&lang=js"

import "./Logo-component.vue?vue&type=style&index=0&id=f294b820&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f294b820"]])

export default __exports__